import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { JobAuditContainerComponent } from './job-audit-container';
import { JobAuditPresenter } from './job-audit-presenter';
import { JobAuditRoute } from './job-audit.route';

@NgModule({
    declarations: [JobAuditContainerComponent, JobAuditPresenter],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [JobAuditRoute]
        })
    ]
})
export class JobAuditModule {}
